// Do not edit directly, this file was auto-generated.

export default {
  IDSmetadata: {
    exportTimestamp: 'Tue, 21 Apr 2026 23:51:10 GMT',
    figmaLastUpdated: 'Tue, 21 Apr 2026 23:27:32 GMT',
    format: 'javascript-esm-react',
    measurementUnits: 'px',
    relatedThemeName: 'none',
    styleDictionaryVersion: '4.4.0',
    targetPlatform: 'all',
    themeName: 'Wireframe',
    tokensetVersion: '1.49.0',
    typographySetName: 'functionalTypography-Core',
  },
  accordion: {
    default: {
      color: {
        body: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          text: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        decorative: {
          accent: '#4d4d4d',
          decorative1: '#000000',
          decorative2: '#000000',
          decorative3: '#000000',
          decorative4: '#000000',
          decorative5: '#000000',
          error: '#000000',
          neutral: '#000000',
          success: '#000000',
          warning: '#ffffff',
        },
        divider: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        expanded: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        header: {
          collapsed: {
            background: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          text: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        sublabel: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
      },
      radius: {
        body: '0',
        header: '0',
      },
      spacing: {
        expandCollapseAllGap: {
          groupGap: '16px',
        },
        small: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '8px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '4px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '8px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
        standard: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '12px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '12px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '16px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '8px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '12px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '12px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
      },
    },
  },
  autocomplete: {
    default: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
    error: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
  },
  avatar: {
    default: {
      color: {
        background: '#e6e6e6',
        border: {
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        content: '#000000',
        focusOutline: '#000000',
        hover: 'rgba(0,0,0,0)',
        hoverOutline: '#000000',
      },
      radius: '9999px',
      sizing: {
        large: '64px',
        medium: '48px',
        small: '32px',
        xl: '120px',
        xs: '24px',
      },
    },
  },
  badge: {
    default: {
      color: {
        background: {
          accent: '#4d4d4d',
          brand: '#000000',
          decorative1: '#000000',
          decorative2: '#000000',
          decorative3: '#000000',
          decorative4: '#000000',
          decorative5: '#000000',
          default: {
            accent: '#4d4d4d',
            brand: '#000000',
            decorative1: '#000000',
            decorative2: '#000000',
            decorative3: '#000000',
            decorative4: '#000000',
            decorative5: '#000000',
            neutral: '#000000',
          },
          dot: '#4d4d4d',
          inverse: {
            accent: '#e6e6e6',
            brand: '#ffffff',
            decorative1: '#e6e6e6',
            decorative2: '#ffffff',
            decorative3: '#ffffff',
            decorative4: '#ffffff',
            decorative5: '#ffffff',
            neutral: '#ffffff',
            neutralInverse: '#ffffff',
          },
          neutral: '#ffffff',
          neutralInverse: '#000000',
          pill: '#4d4d4d',
        },
        border: {
          default: '#000000',
          defaultInverse: '#ffffff',
        },
        label: {
          default: '#000000',
          defaultInverse: '#ffffff',
          pill: '#ffffff',
        },
      },
      radius: {
        dot: '9999px',
        pill: '9999px',
      },
      spacing: {
        standard: {
          min: {
            dotHeight: '20px',
            dotWidth: '20px',
            pillHeight: '20px',
            pillWidth: '20px',
          },
          padding: {
            bottom: '2px',
            left: '4px',
            right: '4px',
            top: '2px',
          },
        },
      },
    },
  },
  banner: {
    default: {
      color: {
        background: '#000000',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(255,255,255,0.48)',
            text: 'rgba(255,255,255,0.48)',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    error: {
      color: {
        background: '#000000',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(255,255,255,0.48)',
            text: 'rgba(255,255,255,0.48)',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    warning: {
      color: {
        background: '#000000',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(0,0,0,0.48)',
            text: 'rgba(0,0,0,0.48)',
          },
          enabled: {
            icon: '#000000',
            text: '#000000',
          },
          focused: {
            icon: '#000000',
            text: '#000000',
          },
          hover: {
            icon: '#000000',
            text: '#000000',
          },
          outline: '#000000',
          pressed: {
            icon: '#000000',
            text: '#000000',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
  },
  blade: {
    default: {
      color: {
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          iconButton: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
          nonscrolling: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            hover: '#000000',
            pressed: '#000000',
          },
          pressed: '#000000',
          scrolling: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#e6e6e6',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        borderDefault: '#000000',
        button: {
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        container: {
          default: '#ffffff',
          enabled: 'rgba(0,0,0,0)',
          hover: 'rgba(0,0,0,0)',
          pressed: 'rgba(0,0,0,0)',
        },
        content: {
          copy: '#000000',
          label: '#000000',
          sublabel: '#000000',
        },
        copy: '#000000',
        label: '#000000',
        sublabel: '#000000',
      },
      sizing: {
        GapMedium: '8px',
        GapSmall: '8px',
        MaxWidthCollapsed: '32px',
        MinWidthExpanded: '320px',
        PaddingHorizontal: '24px',
        PaddingLabelsBottom: '2px',
        PaddingVertical: '16px',
      },
      spacing: {
        GapLarge: '24px',
        GapMedium: '16px',
        GapSmall: '8px',
        PaddingHorizontal: '24px',
        PaddingTitlesBottom: '2px',
        PaddingVertical: '16px',
      },
    },
  },
  breadcrumbs: {
    default: {
      color: {
        current: '#000000',
        separator: '#000000',
      },
      sizing: {
        separator: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        padding: {
          gap: '4px',
        },
      },
    },
  },
  button: {
    default: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        outline: '#000000',
        primary: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#000000',
          shadow: {
            enabled: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      radius: {
        small: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
        standard: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    error: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        outline: '#000000',
        primary: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      radius: {
        small: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
        standard: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColor: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        outline: '#ffffff',
        primary: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          shadow: {
            enabled: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#000000',
        },
        tertiary: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      radius: {
        small: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
        standard: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColorInverse: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        outline: '#000000',
        primary: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          outline: '#000000',
        },
        tertiary: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: '#ffffff',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      radius: {
        small: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
        standard: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    success: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        outline: '#000000',
        primary: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      radius: {
        small: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
        standard: {
          discreet: '0',
          primary: '0',
          secondary: '0',
          tertiary: '0',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
  },
  card: {
    default: {
      color: {
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        container: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        contentBackground: '#e6e6e6',
        danger: '#000000',
        dataViz: {
          solid: '#000000',
          transparent: 'rgba(0,0,0,0.48)',
        },
        decorative1: '#000000',
        decorative2: '#000000',
        decorative3: '#000000',
        decorative4: '#000000',
        decorative5: '#000000',
        icon: '#4d4d4d',
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        neutral: '#000000',
        sublabel: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        success: '#000000',
        warning: '#000000',
      },
      radius: '0',
      spacing: {
        body: {
          content: {
            padding: {
              bottom: '16px',
              gap: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        footer: {
          actions: {
            bottom: '0',
            gap: '8px',
            left: '0',
            right: '0',
            top: '0',
          },
          padding: {
            bottom: '16px',
            gap: '16px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
        },
        header: {
          content: {
            padding: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
          },
          leading: {
            padding: {
              bottom: '0',
              gap: '8px',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          trailing: {
            padding: {
              bottom: '16px',
              gap: '8px',
              left: '0',
              right: '16px',
              top: '16px',
            },
          },
        },
        padding: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chatBubble: {
    default: {
      color: {
        reply: {
          background: '#ffffff',
          senderLabel: '#ffffff',
          text: '#000000',
        },
        user: {
          background: '#e6e6e6',
          senderLabel: '#ffffff',
          text: '#000000',
        },
      },
      radius: {
        reply: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '0',
          topRight: '0',
        },
        user: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '0',
          topRight: '0',
        },
      },
      spacing: {
        footer: {
          actions: {
            gap: '4px',
          },
          gap: '8px',
          top: '4px',
        },
        reply: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        replyWithContent: {
          avatar: {
            bottom: '12px',
            left: '16px',
            right: '16px',
            top: '24px',
          },
          default: {
            bottom: '8px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
          suggestion: {
            actions: {
              bottom: '0',
              gap: '8px',
              left: '16px',
              right: '16px',
              top: '0',
            },
            container: {
              bottom: '24px',
              gap: '16px',
              left: '0',
              right: '0',
              top: '12px',
            },
            header: {
              bottom: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
        },
        user: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
      },
    },
  },
  chatInputField: {
    default: {
      color: {
        scrollbar: 'rgba(0,0,0,0)',
        sendButton: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
        },
      },
      radius: {
        actions: {
          bottomLeft: '0',
          bottomRIght: '0',
          topLeft: '0',
          topRight: '0',
        },
        focus: '0',
        input: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '0',
          topRight: '0',
        },
      },
      spacing: {
        actions: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '8px',
          top: '8px',
        },
        input: {
          bottom: '12px',
          left: '16px',
          right: '16px',
          top: '12px',
        },
      },
    },
  },
  chatbot: {
    default: {
      body: {
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          leftSlot: {
            bottom: '8px',
            gap: '0',
            left: '24px',
            progressIndicator: {
              padding: '0',
            },
            right: '72px',
            top: '8px',
          },
          rightSlot: {
            bottom: '8px',
            gap: '0',
            left: '72px',
            right: '24px',
            top: '8px',
          },
        },
      },
      container: {
        radius: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '0',
          topRight: '0',
        },
        shadow: {
          blur: '24px',
          color: 'rgba(0,0,0,0)',
          spread: '2px',
          x: '0',
          y: '8px',
        },
        sizing: {
          minHeight: '600px',
          minWidth: '600px',
        },
      },
      fab: {
        color: {
          border: 'rgba(255,255,255,0.48)',
          state: {
            disabled: 'rgba(13,13,13,0)',
            enabled: 'rgba(13,13,13,0)',
            focus: 'rgba(13,13,13,0)',
            hover: 'rgba(13,13,13,0.16)',
            pressed: 'rgba(13,13,13,0.32)',
          },
        },
        radius: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '0',
          topRight: '0',
        },
        spacing: {
          left: '8px',
        },
      },
      footer: {
        color: {
          background: 'rgba(153,0,89,0.72)',
          disclaimer: {
            text: {
              enabled: '#ffffff',
            },
            textLink: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              focusOutline: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
        },
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          bottom: '8px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '16px',
        },
      },
      gradient: {
        end: '#4d4d4d',
        start: '#000000',
      },
      header: {
        color: {
          background: 'rgba(37,0,86,0.72)',
          border: 'rgba(255,255,255,0.48)',
          title: '#ffffff',
        },
        spacing: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          rightIcons: {
            gap: '8px',
          },
          top: '16px',
        },
      },
    },
  },
  checkbox: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            unselected: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              focus: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
      },
      radius: {
        control: '0',
        focus: '0',
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            unselected: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              focus: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
      },
      radius: {
        control: '0',
        focus: '0',
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chip: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        icon: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        label: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        outline: '#000000',
      },
      radius: {
        small: '9999px',
        standard: '9999px',
      },
      sizing: {
        small: {
          height: '24px',
          icon: '24px',
        },
        standard: {
          height: '32px',
          icon: '24px',
        },
      },
      spacing: {
        group: {
          gap: '8px',
        },
        small: {
          bottom: '2px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '4px',
            right: '4px',
          },
          left: '2px',
          right: '2px',
          top: '2px',
        },
        standard: {
          bottom: '4px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '8px',
            right: '8px',
          },
          left: '4px',
          right: '4px',
          top: '4px',
        },
      },
    },
  },
  columnSettingsMenu: {
    default: {
      color: {
        background: {
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          frozen: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        border: {
          frozenUnchecked: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        focusOutline: '#000000',
        icon: {
          disabled: 'rgba(153,153,153,0.48)',
          enabled: '#999999',
          focus: '#999999',
          hover: '#777777',
          pressed: '#555555',
        },
        label: {
          default: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          frozen: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        outline: '#000000',
      },
      height: {
        leadingIcon: '21px',
      },
      padding: {
        freezeLine: {
          right: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '24px',
          top: '8px',
        },
      },
      radius: {
        cell: '0',
        column: '0',
        focusOutline: '0',
      },
      strokeWidth: {
        focusOutline: '2px',
      },
    },
  },
  control: {
    default: {
      color: {
        focus: '#000000',
      },
    },
    error: {
      color: {
        focus: '#000000',
      },
    },
  },
  datePicker: {
    default: {
      color: {
        calendar: {
          border: '#000000',
          container: '#ffffff',
        },
        dayOption: {
          badgeEnabled: '#000000',
          badgeHover: '#000000',
          badgeSelected: '#ffffff',
          fillEnabled: '#ffffff',
          fillEnabledHover: '#ffffff',
          fillSelected: '#000000',
          fillSelectedHover: '#000000',
          todayEnabled: '#000000',
          todayHover: '#000000',
          todaySelected: '#ffffff',
        },
        option: {
          badgeEnabled: '#000000',
          badgeHover: '#000000',
          badgeSelected: '#ffffff',
          fillEnabled: '#ffffff',
          fillEnabledHover: '#ffffff',
          fillSelected: '#000000',
          fillSelectedHover: '#000000',
          todayEnabled: '#000000',
          todayHover: '#000000',
          todaySelected: '#ffffff',
        },
        typography: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          selected: '#ffffff',
          static: '#000000',
        },
      },
      minWidth: '104px',
      radius: {
        option: '9999px',
      },
      sizing: {
        containerMinWidth: '320px',
        dayMaxHeight: '40px',
        dayMaxWidth: '40px',
        dialogMaxHeight: '392px',
        dialogMinWidth: '320px',
        optionMaxHeight: '32px',
        optionMinWidth: '64px',
        small: {
          minWidth: '97px',
        },
        standard: {
          minWidth: '114px',
        },
      },
      spacing: {
        calendarGap: '8px',
        dialogPadding: '16px',
        optionRowGap: '16px',
        small: {
          textGap: '4px',
        },
        standard: {
          textGap: '8px',
        },
      },
    },
  },
  divider: {
    default: {
      color: {
        dark: '#000000',
        light: '#000000',
        medium: '#000000',
        semiOpaque: 'rgba(255,255,255,0.48)',
      },
    },
  },
  dragAndDrop: {
    default: {
      background: 'rgba(255,255,255,0)',
    },
  },
  fab: {
    default: {
      radius: {
        bottomLeft: '9999px',
        bottomRight: '9999px',
        topLeft: '9999px',
        topRight: '9999px',
      },
      shadow: {
        blur: '24px',
        color: 'rgba(0,0,0,0)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      sizing: {
        label: {
          min: {
            width: '64px',
          },
        },
        noLabel: {
          height: '40px',
          width: '40px',
        },
      },
    },
  },
  fileUploader: {
    default: {
      color: {
        dropZone: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#000000',
          },
          iconSuccess: {
            enabled: '#000000',
          },
          text: {
            enabled: '#000000',
          },
        },
        help: {
          enabled: '#000000',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '0',
      },
    },
    error: {
      color: {
        dropZone: {
          background: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          border: {
            disabled: '#000000',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          content: {
            disabled: '#000000',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#000000',
          },
          iconSuccess: {
            enabled: '#000000',
          },
          text: {
            enabled: '#000000',
          },
        },
        help: {
          enabled: '#000000',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '0',
      },
    },
  },
  floatingActionColumn: {
    default: {
      border: {
        color: '#000000',
        stroke: '1px',
      },
      padding: {
        gap: '0',
        horizontal: '0',
        vertical: '0',
      },
      radius: {
        radius: '0',
      },
      shadow: {
        blur: '20px',
        color: 'rgba(0,0,0,0)',
        spread: '0',
        x: '-8px',
        y: '0',
      },
    },
  },
  footer: {
    default: {
      color: {
        content: '#000000',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
    defaultInverse: {
      color: {
        content: '#ffffff',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
  },
  functional: {
    borderWidth: {
      focus: {
        default: '2px',
      },
    },
    color: {
      border: {
        accent: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          hover: '#4d4d4d',
          pressed: '#4d4d4d',
        },
        brand: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        danger: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        default: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        'default-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        defaultInverse: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        focus: '#000000',
        'focus-inverse': '#ffffff',
        focusInverse: '#ffffff',
        subtle: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        success: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        transparent: 'rgba(255,255,255,0)',
        warning: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        white: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
      },
      content: {
        accent: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          hover: '#4d4d4d',
          pressed: '#4d4d4d',
        },
        'accent-inverse': {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: 'rgba(230,230,230,1)',
          hover: 'rgba(230,230,230,1)',
          pressed: 'rgba(230,230,230,1)',
        },
        accentInverse: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          hover: '#e6e6e6',
          pressed: '#e6e6e6',
        },
        brand: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        'brand-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        brandInverse: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        danger: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        'danger-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        dangerInverse: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        default: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        'default-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        defaultInverse: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtle: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        'subtle-inverse': {
          disabled: '#ffffff',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtleInverse: {
          disabled: '#ffffff',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        success: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        'success-inverse': {
          disabled: 'rgba(255,255,255,0)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        successInverse: {
          disabled: 'rgba(255,255,255,0)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        warning: {
          disabled: 'rgba(255,255,255,0)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        'warning-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        warningInverse: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
      },
      dataViz: {
        content: {
          axis: '#808080',
          label: '#4d4d4d',
          title: {
            enabled: '#000000',
            hover: 'rgba(0,0,0,0.16)',
            pressed: 'rgba(0,0,0,0.48)',
          },
        },
        five: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
        four: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
        gray: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
        one: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
        six: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
        three: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
        two: {
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          pressed: 'rgba(0,0,0,0.48)',
        },
      },
      decorative: {
        five: {
          contrast: '#000000',
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          inverse: '#ffffff',
          pressed: 'rgba(0,0,0,0.48)',
        },
        four: {
          contrast: '#000000',
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          inverse: '#ffffff',
          pressed: 'rgba(0,0,0,0.48)',
        },
        one: {
          contrast: '#000000',
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          inverse: '#e6e6e6',
          pressed: 'rgba(0,0,0,0.48)',
        },
        three: {
          contrast: '#000000',
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          inverse: '#ffffff',
          pressed: 'rgba(0,0,0,0.48)',
        },
        two: {
          contrast: '#000000',
          enabled: '#000000',
          hover: 'rgba(0,0,0,0.16)',
          inverse: '#ffffff',
          pressed: 'rgba(0,0,0,0.48)',
        },
      },
      surface: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        'background-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        backgroundInverse: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        container: {
          gradient: {
            accent: {
              end: '#333333',
              start: '#333333',
            },
            brand: {
              end: '#000000',
              start: '#000000',
            },
            neutral: {
              end: '#f2f2f2',
              start: '#f2f2f2',
            },
            neutralInverse: {
              end: '#000000',
              start: '#000000',
            },
          },
          opaque: {
            accent: {
              disabled: 'rgba(77,77,77,0)',
              enabled: 'rgba(77,77,77,0)',
              hover: 'rgba(77,77,77,0)',
              pressed: 'rgba(77,77,77,0)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            background: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            brand: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            danger: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            default: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtle: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            success: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warning: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
          },
          solid: {
            accent: {
              disabled: 'rgba(77,77,77,0.48)',
              enabled: '#4d4d4d',
              hover: '#4d4d4d',
              pressed: '#4d4d4d',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: 'rgba(230,230,230,1)',
              hover: 'rgba(230,230,230,1)',
              pressed: 'rgba(230,230,230,1)',
            },
            accentInverse: {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: '#e6e6e6',
              hover: '#e6e6e6',
              pressed: '#e6e6e6',
            },
            brand: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            brandInverse: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            danger: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            dangerInverse: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            default: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            defaultInverse: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            'focus-outline': '#000000',
            'focus-outline-inverse': '#ffffff',
            focusOutline: '#000000',
            focusOutlineInverse: '#ffffff',
            subtle: {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: '#e6e6e6',
              hover: '#e6e6e6',
              pressed: '#e6e6e6',
            },
            subtleInverse: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            success: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            successInverse: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            warning: {
              disabled: 'rgba(232,232,232,0.48)',
              enabled: '#e6e6e6',
              hover: '#efeff0',
              pressed: '#e8e8e8',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            warningInverse: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          translucent: {
            accent: {
              disabled: 'rgba(77,77,77,0.24)',
              enabled: 'rgba(77,77,77,0.40)',
              hover: 'rgba(77,77,77,0.48)',
              pressed: 'rgba(77,77,77,0.56)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            background: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            brand: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            danger: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            default: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtle: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            success: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warning: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
          },
          transparent: {
            accent: {
              disabled: 'rgba(77,77,77,0)',
              enabled: 'rgba(77,77,77,0)',
              hover: 'rgba(77,77,77,0)',
              pressed: 'rgba(77,77,77,0)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            background: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            brand: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            danger: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            default: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtle: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            subtleInverse: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            success: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warning: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
          },
        },
      },
    },
    radius: {
      action: {
        '100': '0',
        '200': '0',
        '300': '9999px',
      },
      circle: '9999px',
      container: {
        '100': '0',
        '200': '0',
        '300': '0',
      },
      content: {
        '100': '9999px',
        '200': '0',
        '300': '0',
        '400': '0',
        '500': '0',
      },
      input: {
        '100': '0',
        '200': '0',
      },
      navigation: {
        '100': '0',
        '200': '0',
      },
      none: '0',
      overlay: {
        '100': '0',
        '200': '0',
      },
    },
    shadow: {
      levelFour: {
        blur: '24px',
        color: 'rgba(0,0,0,0)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      levelOne: {
        blur: '16px',
        color: 'rgba(0,0,0,0)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelThree: {
        blur: '20px',
        color: 'rgba(0,0,0,0)',
        spread: '0',
        x: '0',
        y: '8px',
      },
      levelTwo: {
        blur: '6px',
        color: 'rgba(0,0,0,0)',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      levelTwoHover: {
        blur: '16px',
        color: 'rgba(0,0,0,0)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelTwoPressed: {
        blur: '4px',
        color: 'rgba(0,0,0,0)',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      scrollingOverlay: {
        bottom: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '-8px',
        },
        color: 'rgba(0,0,0,0.08)',
        left: {
          blur: '16px',
          spread: '0',
          x: '8px',
          y: '0',
        },
        right: {
          blur: '16px',
          spread: '0',
          x: '-8px',
          y: '0',
        },
        stroke: '#e6e6e6',
        top: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '8px',
        },
      },
    },
    sizing: {
      action: {
        comfortable: '32px',
        compact: '20px',
        cozy: '24px',
        expanded: '40px',
        spacious: '48px',
        vast: '64px',
      },
      breakpoint: {
        compact: '320px',
        large: '1200px',
        medium: '900px',
        small: '600px',
        xl: '1536px',
      },
      container: {
        comfortable: '320px',
        compact: '48px',
        cozy: '64px',
        expanded: '480px',
        spacious: '600px',
      },
      content: {
        comfortable: '16px',
        compact: '8px',
        cozy: '12px',
        expanded: '20px',
        spacious: '24px',
      },
      input: {
        comfortable: '64px',
        compact: '32px',
        cozy: '40px',
        expanded: '160px',
        spacious: '240px',
      },
      lineHeight: {
        bodyDefault: '24px',
        bodySmall: '21px',
        caption: '20px',
        headline: '53px',
        subheadline: '35px',
        subtile: '30px',
        title: '36px',
      },
      navigation: {
        comfortable: '40px',
        compact: '20px',
        cozy: '24px',
        expanded: '56px',
        spacious: '64px',
      },
      none: '0',
      overlay: {
        comfortable: '64px',
        compact: '24px',
        cozy: '48px',
        expanded: '240px',
        spacious: '480px',
      },
    },
    spacing: {
      action: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '16px',
        spacious: '24px',
      },
      container: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
      content: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '16px',
        spacious: '24px',
      },
      input: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '12px',
        spacious: '16px',
      },
      navigation: {
        comfortable: '16px',
        compact: '4px',
        cozy: '8px',
        expanded: '24px',
        spacious: '32px',
      },
      none: '0',
      overlay: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
    },
  },
  global: {
    motion: {
      default: {
        duration: '200ms',
        easing: 'cubic-bezier(0.38, 0.0, 1, 1)',
        transition: '200ms cubic-bezier(0.38, 0.0, 1, 1)',
      },
      instant: {
        duration: '0ms',
      },
    },
    typography: {
      default: {
        fontFamily: "'Proxima Nova', 'Nunito Sans', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
      },
    },
  },
  grid: {
    color: {
      solid: {
        default: {
          accent: {
            background: '#e6e6e6',
            border: 'rgba(0,0,0,0)',
          },
          brand: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          danger: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          decorative1: {
            background: '#e6e6e6',
            border: 'rgba(0,0,0,0)',
          },
          decorative2: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          decorative3: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          decorative4: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          decorative5: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          neutral: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          success: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
          warning: {
            background: '#ffffff',
            border: 'rgba(0,0,0,0)',
          },
        },
        inverse: {
          accent: {
            background: '#4d4d4d',
            border: 'rgba(255,255,255,0)',
          },
          brand: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          danger: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          decorative1: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          decorative2: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          decorative3: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          decorative4: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          decorative5: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          neutral: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          success: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          warning: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
        },
      },
      translucent: {
        default: {
          accent: {
            background: 'rgba(230,230,230,0)',
            border: 'rgba(0,0,0,0)',
          },
          brand: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          danger: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.56)',
            border: 'rgba(0,0,0,0)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.56)',
            border: 'rgba(0,0,0,0)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.56)',
            border: 'rgba(0,0,0,0)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.56)',
            border: 'rgba(0,0,0,0)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.56)',
            border: 'rgba(0,0,0,0)',
          },
          neutral: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          success: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          warning: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(77,77,77,0.40)',
            border: 'rgba(255,255,255,0)',
          },
          brand: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          danger: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          decorative1: {
            background: 'rgba(0,0,0,0.48)',
            border: 'rgba(255,255,255,0)',
          },
          decorative2: {
            background: 'rgba(0,0,0,0.48)',
            border: 'rgba(255,255,255,0)',
          },
          decorative3: {
            background: 'rgba(0,0,0,0.48)',
            border: 'rgba(255,255,255,0)',
          },
          decorative4: {
            background: 'rgba(0,0,0,0.48)',
            border: 'rgba(255,255,255,0)',
          },
          decorative5: {
            background: 'rgba(0,0,0,0.48)',
            border: 'rgba(255,255,255,0)',
          },
          neutral: {
            background: '#000000',
            border: 'rgba(255,255,255,0)',
          },
          success: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          warning: {
            background: 'rgba(255,255,255,0.48)',
            border: 'rgba(255,255,255,0)',
          },
        },
      },
      transparent: {
        default: {
          accent: {
            background: 'rgba(230,230,230,0)',
            border: 'rgba(0,0,0,0)',
          },
          brand: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          danger: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.08)',
            border: 'rgba(0,0,0,0)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.08)',
            border: 'rgba(0,0,0,0)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.08)',
            border: 'rgba(0,0,0,0)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.08)',
            border: 'rgba(0,0,0,0)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.08)',
            border: 'rgba(0,0,0,0)',
          },
          neutral: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          success: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
          warning: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(0,0,0,0)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(77,77,77,0)',
            border: 'rgba(255,255,255,0)',
          },
          brand: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          danger: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          decorative1: {
            background: 'rgba(0,0,0,0.16)',
            border: 'rgba(255,255,255,0)',
          },
          decorative2: {
            background: 'rgba(0,0,0,0.16)',
            border: 'rgba(255,255,255,0)',
          },
          decorative3: {
            background: 'rgba(0,0,0,0.16)',
            border: 'rgba(255,255,255,0)',
          },
          decorative4: {
            background: 'rgba(0,0,0,0.16)',
            border: 'rgba(255,255,255,0)',
          },
          decorative5: {
            background: 'rgba(0,0,0,0.16)',
            border: 'rgba(255,255,255,0)',
          },
          neutral: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          success: {
            background: 'rgba(0,0,0,0)',
            border: 'rgba(255,255,255,0)',
          },
          warning: {
            background: 'rgba(255,255,255,0)',
            border: 'rgba(255,255,255,0)',
          },
        },
      },
    },
    effects: {
      default: {
        blur: {
          background: '48px',
        },
      },
    },
    layout: {
      default: {
        count: '12px',
        gutter: '16px',
        margin: '0',
      },
    },
    radius: {
      default: {
        default: '0',
      },
      round: {
        default: '16px',
      },
      sharp: {
        default: '0',
      },
    },
    sizing: {
      default: {
        border: '1px',
      },
    },
    spacing: {
      compact: {
        padding: '8px',
      },
      default: {
        padding: '16px',
      },
      spacious: {
        padding: '24px',
      },
    },
  },
  gridlines: {
    default: {
      color: {
        content: {
          enabled: '#4d4d4d',
        },
        grids: {
          enabled: '#808080',
        },
      },
      padding: {
        bottom: '8px',
        gap: '8px',
        left: '8px',
        right: '8px',
        top: '4px',
      },
    },
  },
  hero: {
    accent: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#4d4d4d',
          gradient: {
            stop1: '#333333',
            stop2: '#333333',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    brand: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#000000',
          gradient: {
            stop1: '#000000',
            stop2: '#000000',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    classic: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#000000',
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '16px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    inverse: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#000000',
          gradient: {
            stop1: '#000000',
            stop2: '#000000',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    neutral: {
      color: {
        content: {
          enabled: '#000000',
        },
        surface: {
          enabled: '#ffffff',
          gradient: {
            stop1: '#f2f2f2',
            stop2: '#f2f2f2',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
  },
  icon: {
    IDS: {
      color: {
        internalDesignBackground: '#000000',
      },
      sizing: {
        lg: {
          height: '32px',
          width: '32px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '20px',
          width: '20px',
        },
        xs: {
          height: '16px',
          width: '16px',
        },
      },
    },
    SLDS: {
      color: {
        internalDesignBackground: '#000000',
      },
      sizing: {
        lg: {
          height: '26px',
          width: '26px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '14px',
          width: '14px',
        },
        xs: {
          height: '10px',
          width: '10px',
        },
      },
    },
  },
  iconButton: {
    default: {
      color: {
        background: {
          disabled: 'rgba(0,0,0,0)',
          enabled: 'rgba(0,0,0,0)',
          filled: '#ffffff',
          focus: 'rgba(0,0,0,0)',
          hover: 'rgba(0,0,0,0)',
          pressed: 'rgba(0,0,0,0)',
          selected: '#000000',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
          selected: '#ffffff',
        },
        outline: '#000000',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(0,0,0,0)',
          enabled: 'rgba(0,0,0,0)',
          filled: '#ffffff',
          focus: 'rgba(0,0,0,0)',
          hover: 'rgba(0,0,0,0)',
          pressed: 'rgba(0,0,0,0)',
          selected: '#000000',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
          selected: '#ffffff',
        },
        outline: '#000000',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColor: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0)',
          enabled: 'rgba(255,255,255,0)',
          filled: '#000000',
          focus: 'rgba(255,255,255,0)',
          hover: 'rgba(255,255,255,0)',
          pressed: 'rgba(255,255,255,0)',
        },
        border: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        icon: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        outline: '#ffffff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColorInverse: {
      color: {
        background: {
          disabled: 'rgba(0,0,0,0)',
          enabled: 'rgba(0,0,0,0)',
          filled: '#000000',
          focus: 'rgba(0,0,0,0)',
          hover: 'rgba(0,0,0,0)',
          pressed: 'rgba(0,0,0,0)',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    toggle: {
      color: {
        background: {
          disabled: 'rgba(0,0,0,0)',
          enabled: 'rgba(0,0,0,0)',
          filled: '#ffffff',
          focus: 'rgba(0,0,0,0)',
          hover: 'rgba(0,0,0,0)',
          pressed: 'rgba(0,0,0,0)',
          selected: '#000000',
        },
        border: {
          disabled: '#000000',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
          selected: '#ffffff',
        },
        outline: '#000000',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  label: {
    default: {
      color: {
        asterisk: '#000000',
        optional: '#000000',
        text: '#000000',
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  list: {
    default: {
      color: {
        background: {
          inset: '#e6e6e6',
        },
        border: '#000000',
        scrollbar: 'rgba(0,0,0,0)',
      },
      radius: '0',
      spacing: {
        padding: {
          compact: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '8px',
              top: '8px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          default: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  listItem: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#e6e6e6',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        leadingIcon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        text: {
          label: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          sub: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        trailingIcon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#e6e6e6',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        leadingIcon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        text: {
          label: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          sub: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        trailingIcon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  menu: {
    default: {
      color: {
        background: {
          list: '#ffffff',
        },
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '8px',
          left: '0',
          list: {
            bottom: '8px',
            gap: '0',
            left: '0',
            right: '0',
            top: '8px',
          },
          right: '0',
          top: '0',
        },
      },
    },
  },
  modal: {
    default: {
      color: {
        body: {
          text: '#000000',
        },
        border: '#000000',
        colorBar: '#000000',
        container: '#ffffff',
        header: {
          heading: '#000000',
          subheading: '#000000',
        },
        scrim: 'rgba(0,0,0,0.48)',
      },
      radius: {
        container: '0',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      color: {
        body: {
          text: '#000000',
        },
        border: '#000000',
        colorBar: '#000000',
        container: '#ffffff',
        header: {
          heading: '#000000',
          subheading: '#000000',
        },
        scrim: 'rgba(0,0,0,0.48)',
      },
      radius: {
        container: '0',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    success: {
      color: {
        body: {
          text: '#000000',
        },
        border: '#000000',
        colorBar: '#000000',
        container: '#ffffff',
        header: {
          heading: '#000000',
          subheading: '#000000',
        },
        scrim: 'rgba(0,0,0,0.48)',
      },
      radius: {
        container: '0',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    warning: {
      color: {
        body: {
          text: '#000000',
        },
        border: '#000000',
        colorBar: '#ffffff',
        container: '#ffffff',
        header: {
          heading: '#000000',
          subheading: '#000000',
        },
        scrim: 'rgba(0,0,0,0.48)',
      },
      radius: {
        container: '0',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  navItem: {
    inverse: {
      color: {
        background: {
          control: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          default: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          insetGroup: 'rgba(255,255,255,0)',
          selected: {
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
        },
        border: {
          default: 'rgba(0,0,0,0)',
          focus: '#ffffff',
          selected: '#000000',
        },
        content: {
          control: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          selected: {
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '0',
      },
    },
    neutral: {
      color: {
        background: {
          control: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          insetGroup: 'rgba(0,0,0,0)',
          selected: {
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        border: {
          default: 'rgba(0,0,0,0)',
          focus: '#000000',
          selected: 'rgba(255,255,255,0)',
        },
        content: {
          control: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          default: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          selected: {
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '0',
      },
    },
  },
  navbar: {
    accent: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#000000',
        outline: {
          focus: '#e6e6e6',
        },
        surface: {
          background: {
            enabled: '#4d4d4d',
            gradient: {
              stop1: '#333333',
              stop2: '#333333',
            },
            overlay: 'rgba(77,77,77,0)',
          },
          item: {
            disabled: 'rgba(77,77,77,0)',
            enabled: 'rgba(77,77,77,0)',
            focus: 'rgba(77,77,77,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#000000',
          four: '#4d4d4d',
          one: '#ffffff',
          three: '#000000',
          two: '#000000',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    brand: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#000000',
        outline: {
          focus: '#ffffff',
        },
        surface: {
          background: {
            enabled: '#000000',
            gradient: {
              stop1: '#000000',
              stop2: '#000000',
            },
            overlay: 'rgba(0,0,0,0)',
          },
          item: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#4d4d4d',
          four: '#000000',
          one: '#ffffff',
          three: '#000000',
          two: '#000000',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    classic: {
      color: {
        border: {
          sidebarItem: 'rgba(37,0,86,0.12)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#000000',
        outline: {
          focus: '#ffffff',
        },
        surface: {
          background: {
            enabled: '#000000',
            gradient: {
              stop1: '#000000',
              stop2: '#0076ae',
            },
            overlay: 'rgba(0,0,0,0.16)',
          },
          item: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#ffffff',
          four: '#ffffff',
          one: '#ffffff',
          three: '#ffffff',
          two: '#000000',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '29px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    inverse: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#000000',
        outline: {
          focus: '#ffffff',
        },
        surface: {
          background: {
            enabled: '#000000',
            gradient: {
              stop1: '#000000',
              stop2: '#000000',
            },
            overlay: 'rgba(0,0,0,0)',
          },
          item: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(230,230,230,0.08)',
            pressed: 'rgba(230,230,230,0.12)',
            selected: 'rgba(230,230,230,0.18)',
          },
        },
        wave: {
          five: '#4d4d4d',
          four: '#000000',
          one: '#000000',
          three: 'rgba(0,0,0,0.48)',
          two: '#000000',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    neutral: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
            selected: '#000000',
          },
          text: {
            enabled: '#000000',
          },
        },
        notificationBell: '#000000',
        outline: {
          focus: '#000000',
        },
        surface: {
          background: {
            enabled: '#ffffff',
            gradient: {
              stop1: '#f2f2f2',
              stop2: '#f2f2f2',
            },
            overlay: 'rgba(255,255,255,0)',
          },
          item: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(77,77,77,0.08)',
            pressed: 'rgba(77,77,77,0.12)',
            selected: 'rgba(77,77,77,0.18)',
          },
        },
        wave: {
          five: '#e6e6e6',
          four: '#ffffff',
          one: '#000000',
          three: 'rgba(0,0,0,0.48)',
          two: 'rgba(0,0,0,0)',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  pagination: {
    default: {
      color: {
        barBackground: {
          enabled: '#ffffff',
        },
        barBorder: {
          enabled: '#000000',
        },
        label: {
          enabled: '#000000',
        },
        outline: '#000000',
      },
      padding: {
        multiPage: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        pagination: {
          bottom: '10px',
          gap: '0',
          left: '16px',
          right: '16px',
          top: '10px',
        },
        select: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        singlePage: {
          bottom: '0',
          gap: '0',
          left: '4px',
          right: '4px',
          top: '0',
        },
        tabs: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        textField: {
          left: '4px',
        },
      },
      radius: {
        radius: '0',
      },
    },
  },
  passwordInput: {
    default: {
      spacing: {
        bottom: '0',
        gap: '4px',
        left: '16px',
        right: '0',
        top: '0',
      },
    },
  },
  progressIndicator: {
    default: {
      circular: {
        color: {
          indicator: {
            live: '#000000',
            track: '#ffffff',
          },
          solid: {
            background: '#000000',
            indicator: {
              live: '#ffffff',
              track: '#000000',
            },
            text: '#ffffff',
          },
          transparent: {
            background: 'rgba(255,255,255,0)',
            indicator: {
              live: '#000000',
              track: '#e6e6e6',
            },
            text: '#000000',
          },
        },
        padding: {
          container: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          content: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
          indicator: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        radius: {
          container: '0',
          live: '9999px',
          track: '9999px',
        },
      },
      ids: {
        color: {
          indicator: {
            neutral: '#000000',
            oval1: '#000000',
            oval2: '#000000',
            oval3: '#000000',
            oval4: '#000000',
          },
          solid: {
            background: '#000000',
            text: '#ffffff',
          },
          transparent: {
            background: 'rgba(255,255,255,0)',
            text: '#000000',
          },
        },
        padding: {
          container: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
        },
        radius: {
          container: '0',
        },
      },
      wrapper: {
        color: {
          scrim: {
            blurred: 'rgba(255,255,255,0)',
            solid: '#ffffff',
          },
        },
      },
    },
  },
  progressIndicatorDesignOnly: {
    default: {
      container: 'transparent',
      mode: 'default',
    },
  },
  radio: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            unselected: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              focus: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '0',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            unselected: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              focus: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '0',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  responsiveNavbar: {
    lg: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1535px',
        min: '1200px',
      },
    },
    md: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1199px',
        min: '900px',
      },
    },
    sm: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '899px',
        min: '600px',
      },
    },
    xl: {
      spacing: {
        sm: '8px',
      },
      width: {
        max: '2000px',
        min: '1536px',
      },
    },
    xs: {
      spacing: {
        sm: '2px',
      },
      width: {
        max: '599px',
        min: '320px',
      },
    },
  },
  segmentedControl: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            enabledHover: '#000000',
            enabledPressed: '#000000',
          },
          unselected: '#000000',
        },
        content: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#000000',
          shadow: '#ffffff',
        },
      },
      radius: {
        container: '0',
        group: '0',
      },
      sizing: {
        small: {
          minHeight: '32px',
          minWidth: '32px',
        },
        standard: {
          minHeight: '40px',
          minWidth: '40px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '16px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '16px',
        },
      },
    },
    inverse: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            enabledHover: '#000000',
            enabledPressed: '#000000',
          },
          unselected: '#000000',
        },
        content: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#000000',
          shadow: '#ffffff',
        },
      },
      radius: {
        container: '0',
        group: '0',
      },
      sizing: {
        small: {
          minHeight: '32px',
          minWidth: '32px',
        },
        standard: {
          minHeight: '40px',
          minWidth: '40px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '16px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '16px',
        },
      },
    },
    neutral: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            enabledHover: '#000000',
            enabledPressed: '#000000',
          },
          unselected: '#000000',
        },
        content: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#000000',
          shadow: '#ffffff',
        },
      },
      radius: {
        container: '0',
        group: '0',
      },
      sizing: {
        small: {
          minHeight: '32px',
          minWidth: '32px',
        },
        standard: {
          minHeight: '40px',
          minWidth: '40px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '16px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '16px',
        },
      },
    },
  },
  select: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        help: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        input: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
      },
      outline: '#000000',
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        help: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        input: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
      },
      outline: '#000000',
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  slider: {
    default: {
      color: {
        bar: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
        },
        handle: {
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          fill: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        helpAndValueText: {
          default: '#000000',
          disabled: 'rgba(0,0,0,0.48)',
        },
        helpText: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
        },
        tickMark: {
          bar: {
            default: '#ffffff',
            disabled: 'rgba(255,255,255,0.48)',
          },
          track: {
            default: '#000000',
            disabled: 'rgba(0,0,0,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
          disabled: '#ffffff',
          enabled: '#ffffff',
          fill: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(5,87,213,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(5,87,213,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '20px',
            width: '20px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '32px',
            width: '32px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
    error: {
      color: {
        bar: {
          disabled: '#ffffff',
          enabled: '#000000',
        },
        handle: {
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          fill: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        helpAndValueText: {
          default: '#000000',
          disabled: 'rgba(0,0,0,0.48)',
        },
        helpText: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
        },
        tickMark: {
          bar: {
            default: '#ffffff',
            disabled: 'rgba(255,255,255,0.48)',
          },
          track: {
            default: '#000000',
            disabled: 'rgba(0,0,0,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
          disabled: '#ffffff',
          enabled: '#ffffff',
          fill: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(189,1,0,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(189,1,0,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '20px',
            width: '20px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '32px',
            width: '32px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
  },
  splitButton: {
    default: {
      color: {
        border: {
          primary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
          secondary: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
          tertiary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
        },
      },
      padding: {
        gap: '0',
      },
      radius: {
        button1: '0',
        button2: '0',
        button3: '0',
        button4: '0',
        buttonGroup: '0',
      },
    },
  },
  stepper: {
    default: {
      color: {
        boxBorder: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        completed: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          divider: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
          icon: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          path: {
            enabled: '#000000',
          },
          text: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        focusBorder: '#000000',
        inProgress: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          icon: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          text: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        incomplete: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          divider: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
          icon: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          path: {
            enabled: '#000000',
          },
          text: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      radius: {
        container: '0',
        path: '9999px',
        pathStart: '9999px',
      },
      sizing: {
        box: {
          'max-height': '480px',
          'max-width': '480px',
          'min-height': '64px',
          'min-width': '64px',
        },
        horizontal: {
          max: {
            width: '160px',
          },
        },
        text: {
          max: {
            width: '480px',
          },
          min: {
            height: '48px',
            width: '48px',
          },
        },
      },
      spacing: {
        box: {
          bottom: '8px',
          gap: '8px',
          left: '12px',
          right: '16px',
          text: {
            bottom: '4px',
            top: '4px',
          },
          top: '8px',
        },
        boxGroup: {
          gap: '8px',
        },
        horizontal: {
          gap: '4px',
          gapNegative: '-8px',
          text: {
            side: '16px',
          },
        },
        vertical: {
          gap: '8px',
          path: {
            gap: '2px',
          },
          text: {
            bottom: '8px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  switch: {
    default: {
      color: {
        helpText: '#000000',
        off: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          handle: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        on: {
          background: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          handle: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        outline: '#000000',
      },
      radius: {
        container: '9999px',
        handle: '9999px',
      },
      sizing: {
        small: {
          switch: {
            height: '24px',
            width: '48px',
          },
        },
        standard: {
          switch: {
            height: '32px',
            width: '64px',
          },
        },
      },
      spacing: {
        small: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
        standard: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
      },
    },
  },
  table: {
    default: {
      background: '#ffffff',
      border: {
        color: '#000000',
        colorFrozen: '#000000',
        radius: '0',
        stroke: '1px',
      },
      shadow: {
        blur: '16px',
        color: 'rgba(0,0,0,0)',
        default: {
          blur: '16px',
          color: 'rgba(0,0,0,0)',
          spread: '0',
          x: '0',
          y: '4px',
        },
        frozen: {
          blur: '20px',
          color: 'rgba(0,0,0,0)',
          spread: '0',
          x: '8px',
          y: '0',
        },
        spread: '0',
        x: '0',
        y: '4px',
      },
      shadowFrozen: {
        blur: '20px',
        color: 'rgba(0,0,0,0)',
        spread: '0',
        x: '8px',
        y: '0',
      },
      tableCell: {
        border: {
          control: {
            color: {
              editable: '#000000',
              enabled: '#000000',
              hover: '#000000',
            },
            stroke: '1px',
          },
          head: {
            color: {
              enabled: '#000000',
              hover: '#000000',
              selected: '#000000',
            },
            stroke: '1px',
          },
          text: {
            color: {
              editable: '#000000',
              enabled: '#000000',
              hover: '#000000',
              selected: '#000000',
            },
            stroke: '1px',
          },
          textSelected: {
            stroke: '1px',
          },
        },
        color: {
          control: {
            background: {
              editable: '#ffffff',
              enabled: '#ffffff',
              hover: '#ffffff',
            },
            label: {
              editable: '#000000',
              enabled: '#000000',
              hover: '#000000',
            },
          },
          head: {
            background: {
              enabled: '#ffffff',
              hover: '#ffffff',
              selected: '#ffffff',
            },
            icon: {
              enabled: '#000000',
              hover: '#000000',
            },
            label: {
              enabled: '#000000',
              hover: '#000000',
              selected: '#000000',
            },
          },
          text: {
            background: {
              editable: '#ffffff',
              enabled: '#ffffff',
              hover: '#ffffff',
              selected: '#ffffff',
            },
            label: {
              editable: '#000000',
              enabled: '#000000',
              hover: '#000000',
              selected: '#000000',
            },
          },
        },
        minHeight: '48px',
        padding: {
          control: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '4px',
          },
          head: {
            firstChild: '12px',
            gap: '4px',
            horizontal: '4px',
            lastChild: '12px',
            vertical: '12px',
          },
          text: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '12px',
          },
        },
      },
      tableRowExpanded: {
        color: {
          background: '#ffffff',
          border: '#000000',
          label: '#000000',
        },
        padding: {
          editTop: '16px',
          gap: '32px',
          horizontal: '24px',
          vertical: '8px',
        },
      },
      tableToolbar: {
        color: {
          background: '#ffffff',
          label: '#000000',
        },
        padding: {
          gap: '8px',
          horizontal: '16px',
          vertical: '16px',
        },
      },
    },
  },
  tabs: {
    default: {
      color: {
        background: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          disabled: 'rgba(255,255,255,0)',
          enabled: 'rgba(255,255,255,0)',
          focus: 'rgba(255,255,255,0)',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          nested: 'rgba(255,255,255,0)',
          pressed: '#000000',
          selected: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        icon: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
          selected: {
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
          selected: {
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
            sublabel: '#000000',
          },
        },
        outline: {
          focus: '#000000',
        },
      },
      radius: {
        horizontal: {
          bl: '0',
          bottomLeft: '0',
          bottomRight: '0',
          br: '0',
          tl: '0',
          topLeft: '0',
          topRight: '0',
          tr: '0',
        },
        vertical: {
          bl: '0',
          bottomLeft: '0',
          bottomRight: '0',
          br: '0',
          tl: '0',
          topLeft: '0',
          topRight: '0',
          tr: '0',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        min: {
          height: '40px',
          width: '40px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        tabList: {
          box: {
            bottom: '0',
            gap: '4px',
            left: '0',
            right: '0',
            top: '0',
          },
          line: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
      },
    },
  },
  tag: {
    default: {
      color: {
        background: {
          default: {
            accent: '#4d4d4d',
            brand: '#000000',
            danger: '#000000',
            decorative1: '#000000',
            decorative2: '#000000',
            decorative3: '#000000',
            decorative4: '#000000',
            decorative5: '#000000',
            neutral: '#000000',
            success: '#000000',
            warning: '#e6e6e6',
          },
          inverse: {
            accent: '#e6e6e6',
            brand: '#ffffff',
            danger: '#ffffff',
            decorative1: '#e6e6e6',
            decorative2: '#ffffff',
            decorative3: '#ffffff',
            decorative4: '#ffffff',
            decorative5: '#ffffff',
            neutral: '#e6e6e6',
            success: '#ffffff',
            warning: '#ffffff',
          },
        },
        content: {
          accent: '#4d4d4d',
          brand: '#000000',
          danger: '#000000',
          decorative1: '#000000',
          decorative2: '#000000',
          decorative3: '#000000',
          decorative4: '#000000',
          decorative5: '#000000',
          neutral: '#ffffff',
          neutralInverse: '#000000',
          success: '#000000',
          warning: '#000000',
        },
        icon: '#ffffff',
        label: '#ffffff',
      },
      radius: '0',
      sizing: {
        icon: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        min: {
          height: '20px',
          width: '20px',
        },
        padding: {
          bottom: '1px',
          gap: '4px',
          icon: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          left: '8px',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  textArea: {
    default: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
    error: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
  },
  textField: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        help: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        input: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
        placeholder: '#000000',
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        help: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        input: {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        label: {
          disabled: 'rgba(0,0,0,0.48)',
          focus: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        outline: '#000000',
        placeholder: '#000000',
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
  },
  textLink: {
    default: {
      color: {
        disabled: {
          icon: 'rgba(0,0,0,0.48)',
          text: 'rgba(0,0,0,0.48)',
        },
        enabled: {
          icon: '#000000',
          text: '#000000',
        },
        focus: {
          icon: '#000000',
          text: '#000000',
        },
        hover: {
          icon: '#000000',
          text: '#000000',
        },
        outline: '#000000',
        pressed: {
          icon: '#000000',
          text: '#000000',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        padding: {
          small: {
            gap: '4px',
          },
          standard: {
            gap: '4px',
          },
        },
      },
    },
  },
  timePicker: {
    default: {
      color: {
        background: {
          now: '#ffffff',
        },
        border: {
          root: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
          },
        },
        text: {
          readOnly: '#000000',
        },
      },
    },
  },
  toast: {
    default: {
      color: {
        background: '#000000',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    error: {
      color: {
        background: '#000000',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    success: {
      color: {
        background: '#000000',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    warning: {
      color: {
        background: '#000000',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focused: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          icon: {
            disabled: '#000000',
            enabled: '#000000',
            focused: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          outline: '#000000',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#000000',
            text: '#000000',
          },
          enabled: {
            icon: '#000000',
            text: '#000000',
          },
          focused: {
            icon: '#000000',
            text: '#000000',
          },
          hover: {
            icon: '#000000',
            text: '#000000',
          },
          outline: '#000000',
          pressed: {
            icon: '#000000',
            text: '#000000',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
  },
  toggleButton: {
    default: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              focus: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            border: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            icon: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(0,0,0,0)',
            enabled: 'rgba(0,0,0,0)',
            focus: 'rgba(0,0,0,0)',
            hover: 'rgba(0,0,0,0)',
            pressed: 'rgba(0,0,0,0)',
          },
          icon: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    inverse: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              focus: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              focus: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            border: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#000000',
              pressed: '#000000',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          icon: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  tooltip: {
    default: {
      color: {
        background: '#000000',
        border: '#000000',
        default: {
          background: {
            primary: '#000000',
            secondary: '#ffffff',
          },
          border: {
            secondary: '#000000',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#000000',
            },
          },
        },
        text: '#ffffff',
        title: {
          background: {
            primary: '#000000',
            secondary: '#ffffff',
          },
          border: {
            secondary: '#000000',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#000000',
            },
            title: {
              primary: '#ffffff',
              secondary: '#000000',
            },
          },
        },
      },
      radius: {
        radius: '0',
      },
      sizing: {
        default: {
          min: {
            height: '24px',
            width: '24px',
          },
        },
        max: '480px',
        min: '32px',
        title: {
          min: {
            height: '64px',
            width: '48px',
          },
        },
      },
      spacing: {
        Number: '0',
        default: {
          bottom: '0',
          left: '8px',
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
          right: '8px',
          top: '0',
        },
        title: {
          bottom: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    inverse: {
      color: {
        background: '#ffffff',
        border: '#000000',
        text: '#000000',
        title: {
          label: {
            subtitle: {
              primary: '#ffffff',
            },
            title: {
              primary: '#ffffff',
            },
          },
        },
      },
      radius: {
        radius: '0',
      },
      sizing: {
        max: '480px',
        min: '32px',
      },
      spacing: {
        default: {
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  treeView: {
    default: {
      color: {
        richHeader: '#ffffff',
        selected: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          border: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
        },
        text: {
          subtitle: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            pressed: '#000000',
          },
          title: {
            disabled: 'rgba(0,0,0,0.48)',
            enabled: '#000000',
            focus: '#000000',
            hover: '#000000',
            hyperlink: '#000000',
            pressed: '#000000',
          },
        },
        unselected: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          border: {
            enabled: '#000000',
          },
        },
      },
      padding: {
        small: {
          child: {
            bottom: '8px',
            gap: '8px',
            left: '48px',
            right: '24px',
            top: '8px',
          },
          parent: {
            bottom: '8px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '8px',
          },
        },
        standard: {
          child: {
            bottom: '12px',
            gap: '8px',
            left: '52px',
            right: '24px',
            top: '12px',
          },
          parent: {
            bottom: '12px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '12px',
          },
        },
      },
      radius: '0',
    },
  },
  typography: {
    default: {
      color: {
        default: {
          accent: '#4d4d4d',
          brand: '#000000',
          danger: '#000000',
          decorative1: '#000000',
          decorative2: '#000000',
          decorative3: '#000000',
          decorative4: '#000000',
          decorative5: '#000000',
          neutral: '#000000',
          success: '#000000',
          warning: '#000000',
        },
        inverse: {
          accent: '#e6e6e6',
          brand: '#ffffff',
          danger: '#ffffff',
          decorative1: '#e6e6e6',
          decorative2: '#ffffff',
          decorative3: '#ffffff',
          decorative4: '#ffffff',
          decorative5: '#ffffff',
          neutral: '#ffffff',
          success: '#ffffff',
          warning: '#ffffff',
        },
      },
      sizing: {
        icon: {
          lineHeight: {
            bodyDefault: '24px',
            bodySmall: '21px',
            caption: '20px',
            headline: '53px',
            subheadline: '35px',
            subtitle: '30px',
            title: '36px',
          },
        },
      },
      spacing: {
        gap: {
          bodyDefault: '8px',
          bodySmall: '4px',
          caption: '4px',
          headline: '12px',
          subheadline: '8px',
          subtitle: '8px',
          title: '8px',
        },
      },
    },
    font: {
      fallback: 'Noto Sans, Nunito Sans, Arial, sans-serif',
      family: 'Noto Sans',
      size: {
        '2x': '24px',
        '3x': '28px',
        '4x': '32px',
        '5x': '36px',
        '6x': '40px',
        '7x': '48px',
        '8x': '60px',
        base: '16px',
        lg: '18px',
        sm: '14px',
        xl: '20px',
        xs: '13px',
      },
      weight: {
        black: 900,
        bold: 700,
        heavy: 800,
        light: 300,
        medium: 500,
        regular: 400,
        semibold: 600,
        thin: 200,
      },
    },
    lineHeight: {
      '2x': '35px',
      '3x': '36px',
      '4x': '42px',
      '5x': '48px',
      '6x': '53px',
      '7x': '60px',
      '8x': '72px',
      base: '24px',
      lg: '27px',
      sm: '21px',
      xl: '30px',
      xs: '20px',
    },
    spacing: {
      letter: {
        '2x': '0.48px',
        '3x': '0.80px',
        '4x': '1.00px',
        '5x': '1.20px',
        '6x': '1.40px',
        base: '0.32px',
        lg: '0.32px',
        md: '0.28px',
        negative: {
          lg: '-0.48px',
          md: '-0.32px',
          sm: '-0.26px',
          xl: '-1.00px',
        },
        none: '0',
        sm: '0.26px',
        xl: '0.40px',
      },
      paragraph: {
        '2x': '52.80px',
        '3x': '54.00px',
        '4x': '63.00px',
        '5x': '72.00px',
        '6x': '79.20px',
        '7x': '90.00px',
        '8x': '108.00px',
        base: '36.00px',
        lg: '40.50px',
        none: '0',
        sm: '31.50px',
        xl: '45.00px',
        xs: '29.25px',
      },
    },
  },
  videoPlayer: {
    default: {
      radius: {
        container: '0',
        focus: '0',
      },
    },
  },
};
